/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';
import { PopupMenuItems, PopupMenuItem } from './popupMenuItems';

export interface PopupMenuProps {

  icon?: string;
  text?: string;
  prefix?: string; // name to prefix css classes of 'Menu' | 'Button', 'Icon', 'Text'

  modal?: boolean;
  singleClick?: boolean;
  onOpen?: () => boolean;
  onClose?: () => void;

  transformOrigin?: Mui.PopoverOrigin;
  anchorOrigin?: Mui.PopoverOrigin;

  color?: Mui.Colors;
  variant?: Mui.Style | 'caption' | 'button';

  iconStyle?: any;
  textStyle?: any;
  classes?: any;

  noDownArrow?: boolean;
  items: PopupMenuItem[] | (() => PopupMenuItem[]);
}

/** PopupMenu */
export class PopupMenu extends React.Component<PopupMenuProps, { showMenu?: boolean }> {
  private readonly _menuref = React.createRef<HTMLDivElement>();

  constructor(props: PopupMenuProps, ctx: any) {
    super(props, ctx);
    this.state = {};
  }

  static contextTypes = {
    history: () => null
  };

  handleMenu(event: any) {
    if (this.props.onOpen && !this.props.onOpen()) {
      return; // ignored.
    }
    if (this.props.singleClick && this.props.items.length === 1) {
      this.onClickedItem(this.props.items[0]);
    }
    else {
      this.setState({ showMenu: true });
    }
  }

  handleClose() {
    this.setState({ showMenu: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  private get ariaName() { return (this.props.prefix || 'PopupId'); }
  private cssName(suffix: string) { return (this.props.prefix || '') + (suffix || ''); }

  private onClickedItem(item: PopupMenuItem) {
    try {
      if (item.action) {
        (item.action as any)(event, item);
      }
      if (item.link && this.context.history) {
        this.context.history.push(item.link);
      }
    }
    catch (ex) {
      console.error(ex);
      alert(ex.message);
    }
    finally {
      this.handleClose();
    }
  }

  render() {
    let items: PopupMenuItem[] = [];
    if (this.state.showMenu) {
      if (typeof this.props.items === 'function') {
        items = this.props.items();
      } else {
        items = (this.props.items as PopupMenuItem[]) || items;
      }
    }

    return (
      <div ref={this._menuref} className={this.cssName('')}>
        {this.props.text ? this.renderButton() : this.renderIconButton()}
        <PopupMenuItems
          id={this.ariaName}
          anchor={this._menuref}
          isOpen={!!this.state.showMenu}
          onClose={() => this.handleClose()}
          items={items}
          itemClick={i => this.onClickedItem(i)}
        />
      </div>
    );
  }

  renderIcon() {
    if (this.props.icon) {
      return (
        <Mui.Icon
          className={this.cssName('Icon')}
          color={this.props.color || 'inherit'}
          {...this.props.iconStyle}
        >{this.props.icon}</Mui.Icon>
      );
    }

    return null;
  }


  renderButton() {
    return (
      <Mui.MenuItem
        style={{ color: 'inherit' }}
        className={this.cssName('Menu grow')}
        aria-owns={this.ariaName}
        aria-haspopup="true"
        onClick={e => this.handleMenu(e)}>
        {this.renderIcon()}
        <Mui.Typography
          className={this.cssName('Text grow')}
          color={this.props.color || 'inherit'}
          variant={this.props.variant}
          {...this.props.textStyle}
        >
          {this.props.text}
        </Mui.Typography>
        {!this.props.noDownArrow && (<Mui.Icon
          className={this.cssName('More menu-more')}
          color={this.props.color || 'inherit'}
        >expand_more</Mui.Icon>)}
      </Mui.MenuItem>
    );
  }

  renderIconButton() {
    return (
      <Mui.IconButton
        className={this.cssName('Button')}
        aria-owns={this.ariaName}
        aria-haspopup="true"
        onClick={e => this.handleMenu(e)}
        color={this.props.color || 'inherit'}
        classes={this.props.classes}
      >
        {this.renderIcon()}
      </Mui.IconButton>
    );
  }
}

export default PopupMenu;


// WEBPACK FOOTER //
// ./src/components/popupMenu.tsx